var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4357_3459",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4357_3459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99914 17.0846C9.82192 17.0846 9.67352 17.0247 9.55393 16.9048C9.43421 16.7851 9.37435 16.6367 9.37435 16.4596V10.6263H3.54102C3.36393 10.6263 3.21553 10.5664 3.09581 10.4465C2.97595 10.3266 2.91602 10.1782 2.91602 10.0011C2.91602 9.82387 2.97595 9.67547 3.09581 9.55589C3.21553 9.43616 3.36393 9.3763 3.54102 9.3763H9.37435V3.54297C9.37435 3.36589 9.43428 3.21748 9.55414 3.09776C9.674 2.9779 9.82247 2.91797 9.99956 2.91797C10.1768 2.91797 10.3252 2.9779 10.4448 3.09776C10.5645 3.21748 10.6243 3.36589 10.6243 3.54297V9.3763H16.4577C16.6348 9.3763 16.7832 9.43623 16.9029 9.55609C17.0228 9.67596 17.0827 9.82443 17.0827 10.0015C17.0827 10.1787 17.0228 10.3271 16.9029 10.4467C16.7832 10.5664 16.6348 10.6263 16.4577 10.6263H10.6243V16.4596C10.6243 16.6367 10.5644 16.7851 10.4446 16.9048C10.3247 17.0247 10.1762 17.0846 9.99914 17.0846Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconWhite);
export default __webpack_public_path__ + "static/media/plus-icon-white.9b4cc16ef59a28e148654652fc93b35f.svg";
export { ForwardRef as ReactComponent };